import { FC } from 'react';
import { useRouter } from 'next/router';
import { GameLeaveTool, Routes, DefaultHeaderSkeleton, textBlurStyles } from '@whitesharx/starfall-frontend-core';
import {
  ChallengesLayoutSkeleton,
  LeaveButton,
  PUZZLE_COUNT_IN_SERIES,
  SolvedPuzzles,
} from '@whitesharx/starfall-frontend-core/challenges_screen';
import { UserInfoSkeleton } from '~/src/components/UserInfo/UserInfoSkeleton';
import { PageLayoutSkeleton } from '~/src/components/PageLayout/PageLayoutSkeleton';
import { solvedPuzzlesContainer } from '~/styles/pages/challenges.css';

const PuzzlesSkeletonPage: FC = () => {
  const { push } = useRouter();
  const goToChallenges = () => push(Routes.challenges);
  return (
    <PageLayoutSkeleton
      rightContainer={
        <>
          <UserInfoSkeleton />

          <div className={solvedPuzzlesContainer}>
            <SolvedPuzzles
              key="puzzles"
              solved={0}
              total={PUZZLE_COUNT_IN_SERIES}
              coins={PUZZLE_COUNT_IN_SERIES}
              textClassName={textBlurStyles}
            />
            <LeaveButton onLeave={goToChallenges} textClassName={textBlurStyles} />
          </div>
        </>
      }
    >
      <DefaultHeaderSkeleton leftSlot={<GameLeaveTool key="puzzle-leave-tool" onClick={goToChallenges} />} />

      <ChallengesLayoutSkeleton
        mobileTopContainer={
          <SolvedPuzzles
            key="puzzles"
            solved={0}
            total={PUZZLE_COUNT_IN_SERIES}
            coins={PUZZLE_COUNT_IN_SERIES}
            textClassName={textBlurStyles}
          />
        }
        withHints
      />
    </PageLayoutSkeleton>
  );
};

export default PuzzlesSkeletonPage;
